<div class="ig-empty-state" [class.ig-empty-state--no-graphic]="!imageSrc()">

  <div class="ig-empty-state__inner">

    <div *ngIf="imageSrc()" class="ig-empty-state__graphic" [class.ig-empty-state__graphic--read-only]="readOnly">
      <div class="ig-empty-state__graphic-plus" *ngIf="createBtnLabel !== '' && createBtn && !readOnly">
        <i class="icon-a099_add_alt"></i>
      </div>
      <div class="svg-container" [innerHTML]="svgData()"></div>
    </div>

    <div class="ig-empty-state__content">
      <div class="ig-empty-state__default-content">

        <h2 class="ig-empty-state__title" [class.ig-empty-state__title--read-only]="readOnly" [innerHTML]="readOnly ? messageHeadlineReadOnly : messageHeadline"></h2>
        <div class="ig-empty-state__message" [innerHTML]="readOnly ? messageReadOnly : message | markdown"></div>
        <ig-button
          mode="primary"
          [label]="createBtnLabel"
          *ngIf="createBtnLabel !== '' && createBtn && !readOnly"
          (onClick)="onCreateBtnClick()"
          [disabled]="createBtnDisabled"
          [igTooltip]="createBtnTooltipText"
        ></ig-button>
      </div>

      <div class="ig-empty-state__custom-content">
        <ng-content select="#custom-empty-state-btns"></ng-content>
      </div>

      @if(disclaimer()) {
        <div class="ig-empty-state__documentation-content"><p>{{ disclaimer() }}</p></div>
      }


      @if(!readOnly && productInfoLink()) {
        <div class="ig-empty-state__documentation-content">
          <p [innerHTML]="'LOOK_AT_PRODUCTINFO' | uitranslate: { productInfoLink: productInfoLink() }"></p>
        </div>
      }

      <div class="ig-empty-state__documentation-content" *ngIf="!readOnly && (fullProductDocumentationLink || apiDocumentationLink)">
        <p>
          {{ 'FURTHER_INFORMATION' | uitranslate }}
        </p>

        <div class="ig-empty-state__documentation-links">

          <ig-button
            mode="secondary"
            [label]="'PRODUCT_DOC' | uitranslate"
            *ngIf="fullProductDocumentationLink"
            (onClick)="openInNewTab(fullProductDocumentationLink)"
          ></ig-button>

          <ig-button
            mode="secondary"
            [label]="'API_DOC' | uitranslate"
            *ngIf="apiDocumentationLink"
            (onClick)="onApiDocuBtnClicked()"
          ></ig-button>
        </div>

      </div>

    </div>

  </div>

</div>
